export const DEFAULT_BRAND_SETTINGS = {
  brandName: 'PearlBridge Voyages & Events',
  logo: {
    primary: { url: '/logo.png', format: 'png' },
    footer: { url: '/logo.png', format: 'png' },
    darkMode: { url: '', format: '' },
    lightMode: { url: '', format: '' },
    altText: 'PearlBridge Voyages & Events',
  },
  favicon: {
    url: '/favicon.png',
    size: 512,
    width: 512,
    height: 512,
    format: 'png',
  },
};

const asset = (candidate, fallback) => ({
  ...fallback,
  ...(candidate || {}),
  url: candidate?.url || fallback.url,
});

export function resolveBrandSettings(settings = {}) {
  const logo = settings.logo || {};
  const brandName = settings.brandName || DEFAULT_BRAND_SETTINGS.brandName;
  const primary = asset(
    logo.primary || (settings.logoUrl ? { url: settings.logoUrl } : null),
    DEFAULT_BRAND_SETTINGS.logo.primary
  );

  return {
    brandName,
    logo: {
      primary,
      footer: asset(logo.footer, primary),
      darkMode: asset(logo.darkMode, DEFAULT_BRAND_SETTINGS.logo.darkMode),
      lightMode: asset(logo.lightMode, DEFAULT_BRAND_SETTINGS.logo.lightMode),
      altText: logo.altText || brandName || DEFAULT_BRAND_SETTINGS.logo.altText,
    },
    favicon: asset(
      settings.favicon || (settings.faviconUrl ? { url: settings.faviconUrl } : null),
      DEFAULT_BRAND_SETTINGS.favicon
    ),
  };
}

export function brandAssetUrl(assetValue, fallback = '') {
  return assetValue?.url || fallback;
}
